import React, { useState } from "react";
import inputsValidation from "../../messages/inputValidation";
import "../../style/forms.scss";
import "../../style/alerts.scss";
import { get } from "react-hook-form";
import { FaEye, FaEyeSlash } from "react-icons/fa";

interface IProps {
  type: string;
  name: string;
  text: string;
  isLabel?: boolean;
  register: any;
  errors: any;
  defaultValue?: any;
  isPlaceholder?: boolean;
  max?: string;
}

const FormInput: React.FC<IProps> = ({
  name,
  text,
  isLabel = false,
  type,
  register,
  errors,
  defaultValue,
  isPlaceholder = true,
  max,
}: IProps) => {
  const [showPassword, setShowPassword] = useState(false);

  const handleTogglePassword = () => {
    setShowPassword(!showPassword);
  };

  return (
    <React.Fragment>
      {text && (
        <>
          <div className="form" id={`input-${name}`}>
            {isLabel && <label className="label">{text}</label>}
            <input
              type={type === "password" ? (showPassword ? "text" : "password") : type}
              placeholder={isPlaceholder ? text : ""}
              {...register}
              defaultValue={defaultValue}
              max={max}
            />
            {type === "password" && (
              <span className="password-toggle-icon" onClick={handleTogglePassword}>
                {showPassword ? <FaEyeSlash fontSize={24} /> : <FaEye fontSize={24} />}
              </span>
            )}
            {get(errors, name) && <div className="alert alert-red">*{inputsValidation(errors, name)}</div>}
          </div>
        </>
      )}
    </React.Fragment>
  );
};

export default FormInput;
